<template>
  <section
    id="hero"
    class="ml-6 mr-6"
  >
    <!--
    :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.JPG`)"
        :aspect-ratio="4/3"
    -->
    <v-container class="grey lighten-5">
      <span class="trace">Adapt.vue</span>

      <v-row>
        <v-col
          md="8"
          offset-md="2"
        >
          <h3>Reverse Osmosis or "RO" system</h3>
          <p class="mt-2">
            The primary way we can protect ourselves from water contaminants is to install a Reverse Osmosis system.  The upper photo shows a filtered water faucet on the right side of the sink. This is where the filtered water comes out and is used for drinking.  The main sink faucet still provides the unfiltered water for washing and other purposes.
          </p>
          <v-img
            :src="require(`@/assets/images/water/RO_faucet_IMG_5498-10.jpg`)"
            max-width=800
            class="mx-10"
          >
          </v-img>
          <p class="mt-2">
            The second photo shows the system itself underneath. The vertical filters remove sediment and other contaminants, after which the water goes through a reverse osmosis process to purify it, and then store it in the tank.  The tank then feeds the filtered water faucet above.
          </p>
          <v-img
            :src="require(`@/assets/images/water/RO_basement_IMG_5496-10.jpg`)"
            max-width=800
            class="mx-10"
          >
          </v-img>
          <p class="mt-2">
          The reverse osmosis process was invented by the US Navy to put drinking water on submarines.  It works by using the water pressure on the well water side of the RO and forces the water across the semi-permeable RO membrane, leaving contaminants behind in the reject stream<span v-if="youTube">*</span>.  This is a slow process, which is why the purified water is then fed to a small storage tank<span v-if="youTube">**</span>, so when the filtered water faucet at the sink is used, it doesn't run out of water unless run for a while.
          </p>
          <p class="mt-2">
          The RO equipment easily fits under most kitchen sinks.  And as shown in the photo above, it can also be installed in a basement room directly below the kitchen, with the filtered water piped up through the floor under the sink, provided there is clear access.  Either location works well.
          </p>

          <h3>Benefits</h3>
          <p class="mt-2">
            In addition to contaminants being removed, water from the RO filtration system has a very clean taste.  It can be compared to bottled water.  Below is a photo of a taste test in progress.  "Ted" started drinking more water as soon as his bowl started to be filled with clean-tasting water.
          </p>
          <v-img
            :src="require(`@/assets/images/water/Ted_Bluedrop_IMG_5511.png`)"
            max-width=800
            class="mb-2 mx-10"
          >
          </v-img>

          <h3>Water Protectors Bluedrop Program</h3>

          <p class="mt-2">
            The Water Protectors group has negotiated a volume pricing arrangement with
            <a
            href="http://www.bluedropwater.com/"
            target="_blank"
            >Bluedrop Water</a> to install and service RO systems in Truro.  Bluedrop is a leading supplier of engineered water filtration systems in New England.  Through the program an RO system can be installed with a 15% discount from Bluedrop.  As we all know, it is sometimes difficult to get experts to travel to Truro.  Bluedrop hopes that by working together with CAT it can gain enough customers in Truro so that there is a technician in Truro frequently, thereby providing a high level of service.
          </p>
          <p class="mt-2">
            This program was inspired by the Outer Cape Solarize program managed by the Truro Energy Committee where in the past two years almost 100 Truro residents were able to obtain solar photovoltaic systems at a negotiated lower cost.
          </p>
          <div v-if="youTube">
            <hr>
            <p class="mt-2">
            * Here's a 4&half; minute YouTube video
            <a
            href="https://www.youtube.com/watch?v=qlexW47DtWA"
            target="_blank"
            >How Does a Reverse Osmosis Drinking Water System Work?</a>
            </p>

            <p class="mt-2">
            ** Here's a slightly technical YouTube video <a
            href="https://www.youtube.com/watch?v=2zgC8xED3_M"
            target="_blank"
            >What is a Reverse Osmosis Tank and How Does it Work?</a>
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-btn
          small
          class="mr-2 small"
          @click="wpClick"
        >
          Back to Water Protectors<span class="hidden-md-and-down">...</span>
        </v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {

    components: {
      // ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    name: 'Adapt',

    data: () => ({
      // maxW: 800,
      youTube: false,
    }),

    methods: {

      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },
    },

  }
</script>
